import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "@/components/TopBar";
import NavDrawer from "@/components/NavDrawer";
import CartDrawer from "@/components/CartDrawer";
import Watermark from "@/components/Watermark";

export default function Layout() {
  return (
    <div className="min-h-screen relative">
      <TopBar />
      <NavDrawer />
      <CartDrawer />
      <Watermark />
      <main className="relative z-10 pt-16 pb-16 max-w-5xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
